import { createUseStyles } from 'react-jss'

export default createUseStyles({
  '@keyframes rotate': {
    from: { transform: 'rotate(0deg)' },
    to: { transform: 'rotate(360deg)' }
  },
  container: {
    alignItems: 'center',
    backgroundColor: 'var(--splash-screen__background__color)',
    display: 'flex',
    flex: 1,
    height: '100%',
    justifyContent: 'center'
  },
  icon: {
    animation: '$rotate 2s linear infinite',
    height: 100,
    width: 100
  }
})
